<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>重要提醒</el-breadcrumb-item>
        <el-breadcrumb-item>数据展示</el-breadcrumb-item>
    </el-breadcrumb>

<!--    <el-card class="box-card">
      <div class="warntitle" @click="clickwarntitle">【苏睿司字[2024] 1号】关于官网显示异常的通知</div>
    </el-card> -->

    <!-- 头部用户人数显示 -->
    <el-row :gutter="24">
      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <p class="user">6~18周岁用户数</p>
            <p class="number">{{NumAgeMin}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <p class="user">45~60周岁用户数</p>
            <p class="number">{{NumAgeMax}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <p class="user">体验用户数</p>
            <p class="number">{{Numtotal}}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">大数据</div>
          <!-- 中国地图 -->
          <ve-map :data="mapdata" :settings="mapsettings" :extend="mapextend" :legend-visible="false" style="width: 500px; height: 400px; margin: 0 auto"></ve-map>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">训练时长分布比例</div>
          <!-- 训练时长分布比例 -->
          <ve-histogram :data="trainingData" :extend="trainingExtend" :legend-visible="false" :colors="trainingColors"></ve-histogram>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">用户戴用周期双眼视力变化百分比</div>
          <!-- 用户戴用周期双眼视力变化百分比 -->
          <ve-line :data="effectiveDurationData" :extend="shuangyanshiliExtend" :legend-visible="false" :colors="trainingColors"></ve-line>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">用户年龄分布比例</div>
          <!-- 用户年龄分布 -->
          <ve-line :data="userAgeData" :legend-visible="false" :colors="trainingColors"></ve-line>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">用户视力人数比例</div>
          <!-- 用户视力人数 -->
          <ve-pie :data="visionData" :legend-visible="false"></ve-pie>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">用户使用时间段比例</div>
          <!-- 用户使用时间段 -->
          <ve-bar :data="timeSlot" :legend-visible="false" :extend="timeSlotExtend" :colors="timeSlotColors"></ve-bar>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">用户戴用1-2年屈光度变化值</div>
          <ve-pie :data="quguangdubianhuazhiData" :legend-visible="false"></ve-pie>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">用户群体屈光分类</div>
          <ve-histogram :data="quguangfenleiData" :extend="trainingExtend" :colors="trainingColors" :legend-visible="false"></ve-histogram>
        </el-card>
      </el-col>
    </el-row>

    <!-- 弹出框 -->
    <el-dialog title="未读消息(请到消息中心查看详情)" :visible.sync="displaydialog" width="30%" :close-on-click-modal="false">
      <el-form :model="messageForm" ref="messageFormRef" label-width="70px">
        <el-form-item label="" class="addAdminForm">
          <p v-for="item in messagelist"> 标题： {{item.Title}}</p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 弹出框 end -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyHomePage',
  data () {
    // 中国地图
    this.mapsettings = {
      position: 'china',
      metrics: ['总用户数'],
      itemStyle: {
        normal: {
          borderColor: '#fff',
          areaColor: '#ddf0f8'
        },
        // 选中样式
        emphasis: {
          areaColor: '#80ddff'
        }
      }
    }
    this.mapextend = {
      visualMap: {
        min: 0,
        max: 35000,
        calculable: true,
        inRange: {
          color: ['#E0ffff', '#006edd']
        },
        textStyle: {
          color: '#fff'
        }
      }
    }
    // 训练数据反馈表
    this.trainingExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 20
        })
        return v
      }
    }
    // 训练数据反馈表
    this.shuangyanshiliExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 10
        })
        return v
      }
    }
    // 用户使用时间段
    this.timeSlotExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 10
        })
        return v
      }
    }
    return {
      Numzuori: 0,
      Numshishi: 0,
      Numtotal: 0,
      Numdaoqi: 0,
      NumAgeMin: 0,
      NumAgeMax: 0,
      trainingColors: ['#4ad2ff'],
      timeSlotColors: ['#4ad2ff'],
      mapnum: [
        { address: '南海诸岛', bilv: 0 },
        { address: '西藏', bilv: 5 },
        { address: '内蒙古', bilv: 6 },
        { address: '天津', bilv: 7 },
        { address: '甘肃', bilv: 8 },
        { address: '青海', bilv: 9 },
        { address: '宁夏', bilv: 10 },
        { address: '江西', bilv: 11 },
        { address: '湖北', bilv: 12 },
        { address: '新疆', bilv: 13 },
        { address: '台湾', bilv: 15 },
        { address: '河北', bilv: 17 },
        { address: '湖南', bilv: 19 },
        { address: '黑龙江', bilv: 20 },
        { address: '吉林', bilv: 21 },
        { address: '辽宁', bilv: 22 },
        { address: '安徽', bilv: 24 },
        { address: '重庆', bilv: 25 },
        { address: '上海', bilv: 26 },
        { address: '广西', bilv: 29 },
        { address: '海南', bilv: 30 },
        { address: '四川', bilv: 31 },
        { address: '北京', bilv: 33 },
        { address: '贵州', bilv: 38 },
        { address: '山东', bilv: 39 },
        { address: '广东', bilv: 42 },
        { address: '福建', bilv: 48 },
        { address: '浙江', bilv: 52 },
        { address: '云南', bilv: 60 },
        { address: '江苏', bilv: 62 },
        { address: '陕西', bilv: 83 },
        { address: '河南', bilv: 88 },
        { address: '山西', bilv: 95 }
      ],
      // 中国地图
      mapdata: {
        columns: ['位置', '总用户数'],
        rows: []
      },
      // 训练数据反馈表
      trainingData: {
        columns: ['分类', '百分比'],
        rows: [
          { 分类: '小于30分钟', 百分比: 0.15 },
          { 分类: '30-60分钟', 百分比: 0.25 },
          { 分类: '60-90分钟', 百分比: 0.20 },
          { 分类: '90-120分钟', 百分比: 0.12 },
          { 分类: '120-150分钟', 百分比: 0.11 },
          { 分类: '150-180分钟', 百分比: 0.10 },
          { 分类: '大于180分钟', 百分比: 0.07 }
        ]
      },
      // 用户戴用1-2年屈光度变化值
      quguangdubianhuazhiData: {
        columns: ['分类', '百分比'],
        rows: [
          { 分类: '0', 百分比: 0.45 },
          { 分类: '0.25', 百分比: 0.32 },
          { 分类: '0.50', 百分比: 0.16 }
        ]
      },
      // 用户戴用周期双眼视力变化百分比
      effectiveDurationData: {
        columns: ['日期', '占比'],
        rows: [
          { 日期: '7天提升2行', 占比: 0.95 },
          { 日期: '30天提升3-4行', 占比: 0.91 },
          { 日期: '60天提升3-4行', 占比: 0.9 },
          { 日期: '90天提升3-4行', 占比: 0.87 },
          { 日期: '120天提升3-4行', 占比: 0.85 },
          { 日期: '365天提升3-4行', 占比: 0.8 }
        ]
      },
      // 用户年龄分布
      userAgeData: {
        columns: ['分类', '比例'],
        rows: [
          { 分类: '6-18岁', 比例: 0.51 },
          { 分类: '19-45岁', 比例: 0.25 },
          { 分类: '46-60岁', 比例: 0.15 },
          { 分类: '61岁以上', 比例: 0.09 }
        ]
      },
      // 用户视力人数
      visionData: {
        columns: ['分类', '比例'],
        rows: [
          { 分类: '0.1-0.3', 比例: 0.3895 },
          { 分类: '0.4-0.6', 比例: 0.2761 },
          { 分类: '0.8-1.0', 比例: 0.1676 },
          { 分类: '1.0-1.2', 比例: 0.1181 },
          { 分类: '1.2-2.0', 比例: 0.0487 }
        ]
      },
      // 用户群体屈光分类
      quguangfenleiData: {
        columns: ['分类', '比例'],
        rows: [
          { 分类: '正视', 比例: 0.0398 },
          { 分类: '近视', 比例: 0.8234 },
          { 分类: '远视', 比例: 0.0293 },
          { 分类: '散光', 比例: 0.0409 },
          { 分类: '近视性弱视', 比例: 0.0021 },
          { 分类: '远视性弱视', 比例: 0.0129 },
          { 分类: '散光性弱视', 比例: 0.0043 },
          { 分类: '屈光参差', 比例: 0.0261 },
          { 分类: '老花', 比例: 0.0212 }
        ]
      },
      // 用户使用时间段
      timeSlot: {
        columns: ['分类', '比例'],
        rows: [
          { 分类: '0-6点', 比例: 0.02 },
          { 分类: '6-8点', 比例: 0.12 },
          { 分类: '8-10点', 比例: 0.21 },
          { 分类: '10-12点', 比例: 0.25 },
          { 分类: '12-14点', 比例: 0.35 },
          { 分类: '14-16点', 比例: 0.3 },
          { 分类: '16-18点', 比例: 0.28 },
          { 分类: '18-20点', 比例: 0.42 },
          { 分类: '20-22点', 比例: 0.33 },
          { 分类: '22-24点', 比例: 0.15 }
        ]
      },
      displaydialog: false,
      messageForm: {},
      messagelist: []
    }
  },
  mounted () {
    this.apiGetHomePageData()

    var that = this
    setTimeout(function () {
      that.apiGetMessageCenterUnreadList()
    }, '3000')
  },
  methods: {
    clickwarntitle: function () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/static/20241008.pdf')
    },
    apiGetHomePageData: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetHomePageData, Qs.stringify(data))
        .then(function (response) {
          that.Numzuori = response.data.Numzuori
          that.Numshishi = response.data.Numshishi
          that.Numtotal = response.data.Numtotal
          that.Numdaoqi = response.data.Numdaoqi
          that.NumAgeMin = response.data.NumAgeMin
          that.NumAgeMax = response.data.NumAgeMax
          if (response.data.Employeestype === 0) {
            that.$notify.closeAll()
            that.$notify({
              title: '提示',
              message: '您当前有30天内到期的用户，数量：' + that.Numdaoqi + '个，请点击客户管理，然后点击续费管理查看详情。',
              type: 'warning',
              position: 'bottom-right',
              duration: 0
            })
          }

          that.mapdata.rows = []
          that.mapnum.filter((item1, i1) => {
            var bufNumtotal = parseInt(that.Numtotal * item1.bilv / 1000)
            that.mapdata.rows.push({ 位置: item1.address, 总用户数: bufNumtotal})
          })

          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMessageCenterUnreadList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMessageCenterUnreadList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.messagelist = response.data.List
            if (that.messagelist.length > 0) {
              that.displaydialog = true
            } else {
              that.displaydialog = false
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box-card{
    margin-top: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#999;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
    }
}

.warntitle{
    //display: flex;
    align-items: center;
    color:#ff0000;
    font-size: 30px;
    margin: 0;
    font-weight: bold;
    text-decoration:underline;
    text-align:center;
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
